// Imports
  // React
  import { Link } from 'react-router-dom';
  // Firebase
  import { updateItemStock, deleteItem } from "../firebase/FirebaseClient";
  // Icons
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
  import { faTrashCan } from "@fortawesome/free-solid-svg-icons"




// rafce

const ItemCardEdition = ({ item }) => {


  // Component
  return (
    <div className='item-card-edition'>
      <Link to={`/admin/productos/${item.id}`} >
        <FontAwesomeIcon icon={ faPenToSquare } />
      </Link>
      <p style={ item.stock === 0 ? {color: 'red'} : {color: 'white'}} onClick={() => updateItemStock(item.id, item.stock)} >
        Stock: { item.stock }
      </p>
      <button onClick={() => deleteItem(item.id)}>
        <FontAwesomeIcon icon={ faTrashCan } />
      </button>
    </div>
  )
}

export default ItemCardEdition

